import styled from '@emotion/styled'
import { useCallback, useEffect, useState } from 'react'

import { ApiAsset, ApiDistributionAlert } from '../../../api/_legacy/generated-api'
import { Space } from '../../../components/core-v2'
import { FundCard } from '../../../components/core-v2/molecules/fund-card'
import { actions } from '../state/funds-slice'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { getExDateAlertsFromApiFlags } from '../types/mapper'

export type FundsViewProps = {
  funds: ApiAsset[]
  fundsAlerts: ApiDistributionAlert[]
}

const StyledList = styled.div`
  border-top: solid 1px var(--White90);
  height: calc(100vh - 390px);
  overflow-y: auto;
`

const FundsView = ({ funds, fundsAlerts }: FundsViewProps) => {
  const builderState = useAppSelector(x => x.funds)
  const { selectedFund } = builderState

  const [selectedFundId, setSelectedFundId] = useState<string>(
    selectedFund ? selectedFund.assetId : ''
  )

  const onSelectFund = useCallback(fundId => {
    setSelectedFundId(fundId)
  }, [])

  const dispatch = useAppDispatch()
  useEffect(() => {
    if (selectedFundId) {
      if (selectedFund && selectedFund.assetId === selectedFundId) {
        return
      }
      const selected = funds.find(item => item.assetId === selectedFundId)
      dispatch(actions.setSelectedFund(selected))
    }
  }, [dispatch, funds, selectedFund, selectedFundId])
  useEffect(() => {
    if (selectedFundId) {
      const selectedFundIsInScopeFunds =
        funds.find(item => item.assetId === selectedFundId) !== undefined
      if (!selectedFundIsInScopeFunds) {
        actions.setSelectedFund(undefined)
        setSelectedFundId('')
      }
    }
  }, [funds, selectedFundId])

  const getFundAlerts = (asset: ApiAsset) => {
    const matchingAlert = fundsAlerts && fundsAlerts.find(item => item.assetId === asset.assetId)
    return getExDateAlertsFromApiFlags(matchingAlert)
  }

  return (
    <StyledList key="funds_view_list">
      <Space mt={3}>
        <ul key="funds_list_inner">
          {funds.map(fund => (
            <FundCard
              key={fund.assetId}
              alerts={getFundAlerts(fund)}
              fund={fund}
              isSelected={fund.assetId === selectedFundId}
              onClickFund={() => onSelectFund(fund.assetId)}
            />
          ))}
        </ul>
      </Space>
    </StyledList>
  )
}

export default FundsView
